import type { Content, ContentCollection } from "../../types/content";
import { httpClient } from "./httpClient";

export interface FetchContentParams {
    tags?: string[];
    optionalTags?: string[];
    page?: number;
    limit?: number;
    language?: string;
}

export const fetchContentCollection = (params?: FetchContentParams) => (): Promise<ContentCollection> => {
    return httpClient.get<ContentCollection>("/rest/content", {
        auth: false,
        params: {
            tags: params?.tags && params.tags.length > 0 ? params.tags.join(",") : undefined,
            optionalTags:
                params?.optionalTags && params.optionalTags.length > 0 ? params.optionalTags.join(",") : undefined,
            page: params?.page !== undefined ? Math.max(1, params.page) : undefined,
            limit: params?.limit,
            language: params?.language,
        },
        headers: params?.language ? { "content-language": params.language } : undefined,
    });
};

export const fetchContentById = (contentId?: string) => (): Promise<Content> => {
    if (!contentId) {
        throw new Error("Content ID is required");
    }

    return httpClient.get<Content>(`/rest/content/${contentId}`, { auth: false });
};
